export const DEFAULT_DATE_PICKER_STYLE = {
  paddingTop: 12,
  paddingBottom: 12,
  borderRadius: 8,
  borderWidth: 1,
  borderColor: "#e1e4e8",
};
